import { CREATE, READ } from '../constants/actionTypes'
const productReducers = ( products = [], action ) => {
    switch (action.type) {
        case READ:
            return action.payload
        case CREATE:
            return [...products, action.payload]
        default:
            return products
    }
}

export default productReducers